<template>
  <div>
    <v-row v-if="!$attrs.disabled">
      <template v-for="(banco, index) in principaisBancos">
        <v-col v-if="!hideListaPadrao" :key="index" :data-cy="banco.nome">
          <v-card  @click="selecionar(banco)" flat class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-avatar width="70px" height="80px" v-on="on" tile>
                  <v-img :src="banco.img"
                        contain
                        width="70px"
                        height="60px">
                  </v-img>
                </v-avatar>
              </template>
              <span>{{ banco.Description }}</span>
            </v-tooltip>
          </v-card>
        </v-col>
      </template>
      <v-col cols="12">
        <input-text v-if="!bancoDisabled"
                    :required="$attrs.required"
                    label="Banco"
                    readonly
                    @click="openModal"
                    v-model="model.Banco">
          <template v-slot:append>
            <v-icon @click="openModal" color="primary" class="allow-click-input-disabled">search</v-icon>
          </template>
        </input-text>
        <input-text v-else
                    :required="$attrs.required"
                    label="Banco"
                    readonly
                    disabled
                    v-model="model.Banco" />
        <modal-form v-model="show" :showSubmit="false" textClose="Fechar" size="lg">
          <template v-slot:title>
            Selecione o Banco
            <br />
            <span class="caption pt-1 ml-3">Clique na linha do Banco desejado para selecionar</span>
          </template>
          <template v-slot:body>
            <core-grid mobile-breakpoint="0" modal flat ref="grid" dense :onRead="onRead" :editOption="false" :deleteOption="false" :addOption="false" :schema="schema" @click="selecionar">
            </core-grid>
          </template>
        </modal-form>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <input-text label="Banco" v-model="model.Banco" readonly disabled required />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    listBancosPossiveis: { type: Array, default: null },
    hideListaPadrao: { type: Boolean, default: false },
    listBancosPrincipais: {
      type: Array,
      default: () => [125, 4, 1, 6, 2, 3, 119]
    },
    bancoDisabled: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      principaisBancos: [],
      bancos: [],
      show: false,
      schema: [
        { value: 'ID', text: 'Código' },
        { value: 'Description', text: 'Descrição' }
      ]
    }
  },
  methods: {
    selecionar: function (curr) {
      const th = this
      th.$api.UI.Confirmacao('info', 'Confirma a Seleção do Banco: ' + curr.ID + ' - ' + curr.Description + '?', function () {
        th.$set(th.model, 'CodigoBanco', curr.ID);
        th.$set(th.model, 'Banco', curr.Description);
        th.$set(th.model, 'NroBanco', curr.Code);
        th.$emit('emitted', curr)
        th.show = false
      })
    },
    openModal: function () {
      this.show = true
    },
    onRead: function (options) {
      options.success(this.bancos)
    },
  },
  mounted () {
    const th = this;
    th.$api.Multiplo.Select({ filter: { tipoRegistro: 201 } }).then(
      function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (response.Result) {
            try {
              th.bancos = JSON.parse(response.JSON);
              if (th.listBancosPossiveis) { th.bancos = th.bancos.filter(p => th.listBancosPossiveis.includes(p.ID)); }
              th.listBancosPrincipais.forEach(bancoID => {
                const banco = th.bancos.find(el => el.ID === bancoID);
                switch (bancoID) {
                  case 1: banco.icone = 'banco-do-brasil.svg'; banco.nome = 'Banco do Brasil'; break;
                  case 2: banco.icone = 'caixa-economica-federal.svg'; banco.nome = 'Caixa Economica'; break;
                  case 3: banco.icone = 'itau.svg'; banco.nome = 'Itaú'; break;
                  case 4: banco.icone = 'bradesco.svg'; banco.nome = 'Bradesco'; break;
                  case 6: banco.icone = 'santander.svg'; banco.nome = 'Santander'; break;
                  case 38: banco.icone = 'sicredi.svg'; banco.nome = 'Sicredi'; break;
                  case 114: banco.icone = 'sicoob.svg'; banco.nome = 'Sicoob'; break;
                  case 119: banco.icone = 'nubank.svg'; banco.nome = 'Nubank'; break;
                  case 125: banco.icone = 'bmp.svg'; banco.nome = 'Banco Money Plus'; break;
                  case 81: banco.icone = 'autocred.svg'; banco.nome = 'Banco Rendimento'; break;
                  case 204: banco.icone = 'picpay.svg'; banco.nome = 'PicPay'; break;
                  case 310: banco.icone = 'bmp.svg'; banco.nome = 'BMP SCD S.A'; break;
                }
                banco.img = require(`../assets/imgs/${banco.icone}`);

                th.principaisBancos.push(banco);
              })
            } catch { }
          }
        }
      }
    )
  }
}
</script>
